/* NMD backorder (added 2026-10-15).
   Product pages: when the selected variant is backordered (variant metafield custom.backorder_date set,
   out of stock, continue selling on), show "Backordered Expected Release Date: MM/DD/YYYY", label the
   add-to-cart button "Backordered" and send a "Backordered" line item property.
   Per-variant dates come from the Liquid-rendered JSON #BackorderData-<section>. Dawn's
   VariantSelects.toggleAddButton resets the button label, so it is wrapped here. */
(function () {
  function sync(vs) {
    try {
      var sec = vs.dataset.section;
      var dataEl = document.getElementById('BackorderData-' + sec);
      var map = dataEl ? JSON.parse(dataEl.textContent || '{}') : {};
      var v = vs.currentVariant;
      var date = v ? map[String(v.id)] : null;
      var msg = document.getElementById('Backorder-' + sec);
      if (msg) {
        var d = msg.querySelector('.nmd-backorder__date');
        if (d) d.textContent = date || '';
        msg.hidden = !date;
      }
      var form = document.getElementById('product-form-' + sec);
      if (!form) return;
      var prop = form.querySelector('.nmd-backorder-prop');
      if (prop) {
        prop.value = date ? 'Expected Release Date: ' + date : '';
        prop.disabled = !date;
      }
      var btn = form.querySelector('[name="add"]');
      var txt = form.querySelector('[name="add"] > span');
      if (btn && txt && date && !btn.hasAttribute('disabled')) txt.textContent = 'Add To Cart \u2013 Backordered';
    } catch (e) {}
  }
  function patch() {
    var VS = customElements.get('variant-selects');
    if (!VS || VS.prototype.__nmdBackorder) return;
    var orig = VS.prototype.toggleAddButton;
    VS.prototype.toggleAddButton = function () {
      var r = orig.apply(this, arguments);
      sync(this);
      return r;
    };
    var origUn = VS.prototype.setUnavailable;
    if (origUn) VS.prototype.setUnavailable = function () { var r = origUn.apply(this, arguments); sync(this); return r; };
    VS.prototype.__nmdBackorder = true;
  }
  if (window.customElements) customElements.whenDefined('variant-selects').then(patch);
})();
